<template>
  <section class="list">
    <slot name="infinite-scroll-list" />
    <div ref="scrollMonitorEl"></div>
  </section>
</template>
<script setup>
  // catalog view more 용 infinite scroll list
  // pc 와 동일한 구조로 변경 InfinityScrollCellList => InfiniteScrollList
  import { ref, onMounted, defineEmits } from 'vue'
  import scrollMonitor from 'scrollmonitor'

  const emit = defineEmits(['load-more-fn'])

  const scrollMonitorEl = ref(null)
  const watcher = ref(null)

  const emitDataLoadMore = () => {
    return emit('load-more-fn')
  }

  const setScrollMonitor = () => {
    const monitorEl = scrollMonitorEl.value
    watcher.value = scrollMonitor.create(monitorEl, 500)
    watcher.value.enterViewport(emitDataLoadMore)
  }

  onMounted(() => {
    setScrollMonitor()
  })
</script>
